import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItemButton,
    ListItemText,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { beautifyNumber } from '../../../Utils/FormatNumber';

/**
 * Dialog to pick one of multiple item prices.
 * prices: [{ id?, name, amount, isDefault }]
 */
export default function ItemPricePickerDialog({
    open,
    prices = [],
    itemName = '',
    onSelect,
    onClose,
    direction = 'rtl',
}) {
    const { t } = useTranslation();

    return (
        <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="xs" dir={direction}>
            <DialogTitle>{t('ChooseItemPrice')}</DialogTitle>
            <DialogContent>
                {itemName ? (
                    <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                        {itemName}
                    </Typography>
                ) : null}
                <List>
                    {prices.map((p, index) => {
                        const label = p.name
                            ? `${p.name} — ${beautifyNumber(p.amount)}`
                            : beautifyNumber(p.amount);
                        return (
                            <ListItemButton
                                key={p.id || index}
                                onClick={() => onSelect && onSelect(p)}
                                sx={{
                                    borderRadius: 1,
                                    mb: 0.5,
                                    border: p.isDefault ? '1px solid #304FFF' : '1px solid #eee',
                                }}
                            >
                                <ListItemText
                                    primary={label}
                                    secondary={p.isDefault ? t('DefaultPrice') : null}
                                />
                            </ListItemButton>
                        );
                    })}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('Cancel')}</Button>
            </DialogActions>
        </Dialog>
    );
}
